import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import Cookies from 'js-cookie';

interface AuthContextType {
    authData: any;
    setAuthData: (data: any) => void;
    saveAuthData: (data: any, remember: boolean) => void;
    getAuthData: () => any | undefined;
    clearAuthData: () => void;
}

// コンテキスト作成
const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [authData, setAuthData] = useState<any>(null); 
    const [loading, setLoading] = useState(true); // ローディング状態

    // 初期化時にクッキーから認証情報を取得
    useEffect(() => {
        const savedAuthData = Cookies.get('authData');
        if (savedAuthData) {
            setAuthData(JSON.parse(savedAuthData));
        }
        setLoading(false); // ローディング完了
    }, []);

    // 認証情報をクッキーに保存
    const saveAuthData = (data: any, remember: boolean = false) => {
        setAuthData(data);
        if (remember) {
            // expire7日
            Cookies.set('authData', JSON.stringify(data), { expires: 7, path: '/' });
        } else {
            // expireなし（セッションのみ）
            Cookies.set('authData', JSON.stringify(data), { path: '/' });
        }
    };

    const getAuthData = () => {
        const authData = Cookies.get('authData');
        return authData ? JSON.parse(authData) : undefined;
    }

    // 認証情報をクッキーから削除
    const clearAuthData = () => {
        setAuthData(null);
        Cookies.remove('authData');
    };

    if (loading) {
        return <div>Loading...</div>; // ローディング中はLoadingを表示
    }

    return (
        <AuthContext.Provider value={{ authData, setAuthData, saveAuthData, getAuthData, clearAuthData }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
